import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function ActionItems() {
  return (
    <PageTemplate
      title="Sites: Action Items"
      tooltipText="Explore CTMS action items across study sites."
      type="ctms-action-item"
      selectionIdentifierColumn="site"
      constants={{
        wikiLink: "/wiki/guides/exploration-dashboard-studio-overview",
        idLink: undefined,
      }}
    />
  );
}
